module.exports = __webpack_public_path__ + "img/惊讶.3e01380d.png";